import { useEffect, useContext, useMemo } from 'react';
import { useNotificationHelpers } from './useNotificationHelpers';
import { I18nContext } from '../contexts/I18nContext';
import { notificationService } from '../services/notificationService';

// Stable fallback translation function
const fallbackT = (key: string) => key;

export const useNotificationService = () => {
  const notificationHelpers = useNotificationHelpers();
  
  // Safely get I18n context - check if it's available without throwing
  const i18nContext = useContext(I18nContext);
  const t = useMemo(() => i18nContext?.t || fallbackT, [i18nContext?.t]);

  useEffect(() => {
    // Set the notification helpers and translation function in the service
    notificationService.setNotificationHelpers(notificationHelpers);
    notificationService.setTranslateFunction(t);
  }, [notificationHelpers, t]);

  return notificationService;
};

export default useNotificationService;